import { render } from "./trendsDetail.vue?vue&type=template&id=6b596b85&scoped=true"
import script from "./trendsDetail.vue?vue&type=script&lang=js"
export * from "./trendsDetail.vue?vue&type=script&lang=js"

import "./trendsDetail.vue?vue&type=style&index=0&id=6b596b85&lang=less&scoped=true"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b596b85"]])

export default __exports__